<template>
  <div class="page-master" >
    <div v-if="'{}' != JSON.stringify(components) && '{}' != JSON.stringify(tablelist)" >
        <div v-show="showType == 'search'">          
          <jr-searchgroup v-model="queryParam.queryData['CT0010000000001']" :components="components['CT0010000000001']"  :badge="badge"  :selectData="selectData" @badge-click="badgeClick"></jr-searchgroup>
          <jr-button @click="query('Button')" :components="components['CT0010000000002']" :loading="queryLoding"  :badge="badge" @badge-click="badgeClick" type="primary" icon="el-icon-search">查询</jr-button>
          <jr-button @click="resetClick" :components="components['CT0010000000003']" :badge="badge" @badge-click="badgeClick" type="warning" icon="el-icon-refresh">重置</jr-button>
          <jr-buttongroup @click="createUser" :components="components['CT0010000000004']" :badge="badge" @badge-click="badgeClick" type="success" icon="el-icon-plus" :items="['复制并新增']">新增</jr-buttongroup>
          <jr-button @click="showWhereMore" :components="components['CT0010000000005']" :badge="badge" @badge-click="badgeClick" type="primary" icon="el-icon-zoom-in">更多条件</jr-button>
          <br><jr-labelwhere :queryData="queryParam.queryData" width="800px"></jr-labelwhere>
          <br><jr-bigtable :queryParam="queryParam" :tableData="tableData" :pageTotal="pageTotal" :components="tablelist['TP0000000000001']" @sort-change="sortChange"></jr-bigtable>          
          
        </div>
      
        <div v-if="showType == 'input' || showType == 'edit'">
          <jr-button :components="components['CT0010000000006']" :badge="badge" @badge-click="badgeClick" type="success" icon="el-icon-edit">修改</jr-button>
          <jr-button :components="components['CT0010000000007']" :badge="badge" @badge-click="badgeClick" type="primary" icon="el-icon-save">保存</jr-button>
          <jr-button @click="" :components="components['CT0010000000028']" :badge="badge" @badge-click="badgeClick" type="warning" icon="el-icon-edit">密码重置</jr-button>
          <jr-button @click="showType = 'search'" :components="components['CT0010000000008']" :badge="badge" @badge-click="badgeClick" type="danger" icon="el-icon-exit">退出</jr-button>
          <br>          
          <jr-input v-model="createData['CT0010000000009'].controlDefaultvalue" :components="components['CT0010000000009']" :badge="badge" @badge-click="badgeClick"></jr-input>
          <jr-input v-model="createData['CT0010000000010'].controlDefaultvalue" :components="components['CT0010000000010']" :badge="badge" @badge-click="badgeClick"></jr-input>
          <jr-input v-model="createData['CT0010000000012'].controlDefaultvalue" :components="components['CT0010000000012']" :badge="badge" @badge-click="badgeClick"></jr-input>
          <jr-input v-model="createData['CT0010000000011'].controlDefaultvalue" :components="components['CT0010000000011']" :badge="badge" @badge-click="badgeClick"></jr-input>
          <br>
          <jr-select v-model="createData['CT0010000000013'].controlDefaultvalue" :selectData="$store.getters.stationCut" :selectDataParam="{'label':'stationName', 'value':'stationId'}"  :components="components['CT0010000000013']" :badge="badge" @badge-click="badgeClick"></jr-select>
          <jr-select v-model="createData['CT0010000000014'].controlDefaultvalue" :selectData="$store.getters.department" :selectDataParam="{'label':'departmentName', 'value':'departmentId'}"  :components="components['CT0010000000014']" :badge="badge" @badge-click="badgeClick"></jr-select>
          <jr-select v-model="createData['CT0010000000015'].controlDefaultvalue" :selectData="$store.getters.sysTypeAll['职务'].childSysType" :selectDataParam="{'label':'typeName', 'value':'typeId'}" :components="components['CT0010000000015']" :badge="badge" @badge-click="badgeClick"></jr-select>
          <jr-select v-model="createData['CT0010000000016'].controlDefaultvalue" :selectData="sex" :components="components['CT0010000000016']" :badge="badge" @badge-click="badgeClick"></jr-select>
          <br>
          <jr-input v-model="createData['CT0010000000018'].controlDefaultvalue" :components="components['CT0010000000018']" :badge="badge" @badge-click="badgeClick"></jr-input>
          <jr-select v-model="createData['CT0010000000019'].controlDefaultvalue" :selectData="existsType" :components="components['CT0010000000019']" :badge="badge" @badge-click="badgeClick"></jr-select>
          <jr-datetime v-model="createData['CT0010000000020'].controlDefaultvalue" :components="components['CT0010000000020']" :badge="badge" @badge-click="badgeClick"></jr-datetime>
          <jr-select v-model="createData['CT0010000000021'].controlDefaultvalue" :selectData="yesOrno" :components="components['CT0010000000021']" :badge="badge" @badge-click="badgeClick"></jr-select>
          <br>
          <jr-datetime v-model="createData['CT0010000000022'].controlDefaultvalue" :components="components['CT0010000000022']" :badge="badge" @badge-click="badgeClick"></jr-datetime>
          <jr-input v-model="createData['CT0010000000023'].controlDefaultvalue" :components="components['CT0010000000023']" :badge="badge" @badge-click="badgeClick"></jr-input>
          <jr-input v-model="createData['CT0010000000024'].controlDefaultvalue" :components="components['CT0010000000024']" :badge="badge" @badge-click="badgeClick"></jr-input>
          <jr-datetime v-model="createData['CT0010000000026'].controlDefaultvalue" :components="components['CT0010000000026']" :badge="badge" @badge-click="badgeClick"></jr-datetime>
          <br>
          <jr-inputarea v-model="createData['CT0010000000025'].controlDefaultvalue" :components="components['CT0010000000025']" :badge="badge" @badge-click="badgeClick"></jr-inputarea>
          <jr-datetime v-model="createData['CT0010000000027'].controlDefaultvalue" :components="components['CT0010000000027']" :badge="badge" @badge-click="badgeClick"></jr-datetime>
          

          
        </div>
        <jr-wheremore v-model="queryParam.queryData" :showDialog="showDialog" :components="components" :badge="badge" ref="wheremore" @badge-click="badgeClick"></jr-wheremore>
    </div>
  </div>
</template>
<script>
import store from '@/store'
import { initpage } from '@/api/pagetable'
import { query } from '@/api/public'
import JRGLOBAL from '@/api/jrglobal'
export default {
  name: 'User',
  deactivated(){
    if(store.getters.closePageNames==this.$options.name){
        this.$destroy(this.$options.name)
    }
  },
  created() {
    this.initpage(this.$options.name)
  },
  data () {
    return {
      // 后台传递的组件对象
      components: {},
      // 表格对象的相关属性
      tablelist: {},
      // 查询页面和录入表单页面状态标识，默认search  录入input
      showType: 'search',
      // 搜索页面查询条件组件条件选项集
      selectData: [{id: 'userLoginname',value: '登陆名'}, {id: 'userRealname',value: '姓名'}, {id: 'userCode',value: '工号'}, {id: 'userPhone',value: '手机号'}, {id: 'helpCode',value: '助记码'}],
      // 页面所有查询条件对象集合
      queryParam: {
        queryPath: '/home/user/queryuser',
        // 查询条件相关参数
        queryData: {},
        queryLimit: {
          table: "",
          sort: "",
          order: "asc",
          offset: 0,
          limit: 100
        }
      },
      // 页面所有录入明细的对象集合
      createData: {},
      // 表格数据集
      tableData: [],
      // 查询按钮状态属性
      queryLoding: false,
      // 性别
      sex: JRGLOBAL.sex,
      // 是否
      yesOrno: JRGLOBAL.yesOrno,
      // 是否有效
      existsType: JRGLOBAL.existsType,
      // 更多查询条件
      showDialog: false,
      pageTotal: {},      
      t: {}
      
    }
  },
  props: {
    badge: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    badgeClick(id,bv) {
      this.components[id]['controlRighttype'] = bv        
    },
    sortChange(queryLimit, queryType) {
      this.queryParam.queryLimit = queryLimit
      this.query(queryType)
    },
    // 页面加载
    initpage(pageName) {
      initpage(pageName).then(res => {
        const code = res.status.code    
        if(code == 200){
          const tablelist = res.data.tablelist
          tablelist.forEach(item=>{
            this.$set(this.tablelist, item.tableId, item)
          })
          // 设置默认pageSize
          this.queryParam.queryLimit.limit = this.tablelist['TP0000000000001'].tablePagesize
          const components = res.data.pagetablelist
          components.forEach(item=> {
            this.$set(this.components, item.controlId, item)
            if(item.controlGroup == 'Search' || item.controlGroup == 'SearchMore'){
              this.$set(this.queryParam.queryData, item.controlId, item)
            }
          })
          this.queryParam.queryData = JSON.parse(JSON.stringify(this.queryParam.queryData))
        }
      })
      .catch(error => {
        return Promise.reject('error')
      })
      //this.$forceUpdate()     
    },
    // 重置按钮
    resetClick() {
      this.queryParam.queryData = {}
      for(var key in this.components){
        if(this.components[key].controlGroup == 'Search' || this.components[key].controlGroup == 'SearchMore'){
          this.$set(this.queryParam.queryData, this.components[key].controlId, this.components[key])
        }
      }
      this.queryParam.queryData = JSON.parse(JSON.stringify(this.queryParam.queryData))
      this.tableData = []    
      this.pageTotal = {}
    },
    // 查询按钮
    query(type) {
      if(type ==  'None'){
        return
      }
      if(type == 'Button'){
        this.queryParam.queryLimit.offset = 0
      }
      this.queryLoding = true
      query(this.queryParam).then(res => {
        const code = res.status.code    
        if(code == 200){
          const tableData = res.data.userlist           
          this.tableData = tableData
          this.pageTotal = res.total
        }
        this.queryLoding = false
      })
      .catch(error => {
        this.queryLoding = false
        return Promise.reject('error')
      })
    },
    // 新增按钮事件
    createUser() {
      this.createData = {}
      for(var key in this.components){
        if(this.components[key].controlGroup == 'Input'){
          this.$set(this.createData, this.components[key].controlId, this.components[key])
        }
      }
      this.createData = JSON.parse(JSON.stringify(this.createData))
      this.showType = 'input'
    },
    // 显示更多查询条件窗口
    showWhereMore() {
      this.$refs.wheremore.showType()      
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/basic/User.vue